import Aion from '@adoratorio/aion';

export default new Aion();
